module.exports = __webpack_public_path__ + "img/organizacao-plataforma.b187bde7.gif";